import Modal from "../components/Modal";
import {primaryColors, backgroundColors} from "./data";
import PrimaryColor from "./PrimaryColor";
import BackgroundColor from "./BackgroundColor";
import "./theme.css"

const Theme = () => {
	return (
		<Modal className="theme__modal">
			<h3>customize your theme</h3>
			<small>Change the primary and background color to your preference.</small>
			<div className="theme__primary-wrapper">
				<h5>Primary Color</h5>
				<div className="theme__primary-colors">
				{primaryColors.map(primcol=>(
					<PrimaryColor key={primcol.className} className={primcol.className}/>
				))}
				</div>
			</div>
			<div className="theme__background-wrapper">
				<h5>Background Color</h5>
				<div className="theme__background-colors">
				{backgroundColors.map(backcol=>(
					<BackgroundColor key={backcol.className} className={backcol.className}/>
				))}
				</div>
			</div>
		</Modal>
	)
}

export default Theme